import { gql } from '@apollo/client'

export const getOnboardingCompletion = gql`
  query GetOnboardingCompletion {
    getOnboardingCompletion
  }
`
